import { Injectable } from '@angular/core';

export class CurrencyName {
    name: string;
}

@Injectable()
export class CurrencyNameService {
    currencies: CurrencyName[] = [
        { name: "درهم الإمارات العربية المتحدة" },
        // { name: "أفغاني أفغاني" },
        { name: "ليك ألباني" },
        { name: "درام أرمني" },
        // { name: "غيلدر جزر الأنتيل الهولندية" },
        // { name: "الكوانزا الأنغولية" },
        { name: "بيزو أرجنتيني" },
        { name: "دولار أسترالي" },
        // { name: "فلورين أروبي" },
        // { name: "مانات أذربيجان" },
        // { name: "مارك البوسنة والهرسك القابل للتحويل" },
        // { name: "دولار البربادوسي" },
        // { name: "التاكا البنغلاديشي" },
        // { name: "الليف البلغاري" },
        { name: "دينار بحريني" },
        // { name: "فرنك بوروندي" },
        // { name: "دولار برمودا" },
        // { name: "دولار بروناي" },
        { name: "بوليفيانو بوليفي" },
        { name: "ريال برازيلي" },
        // { name: "دولار بهامي" },
        // { name: "بيتكوين" },
        // { name: "نغولتروم بوتاني" },
        // { name: "البولا البوتسوانية" },
        { name: "روبل بيلاروسي" },
        // { name: "دولار بليزي" },
        { name: "دولار كندي" },
        // { name: "فرنك كونغولي" },
        { name: "فرنك سويسري" },
        // { name: "وحدة حساب تشيلية (UF)" },
        { name: "بيزو تشيلي" },
        // { name: "يوان صيني (في الخارج)" },
        { name: "يوان صيني" },
        { name: "بيزو كولومبي" },
        { name: "كولون كوستاريكي" },
        // { name: "بيزو كوبي قابل للتحويل" },
        { name: "بيزو كوبي" },
        { name: "إسكودو الرأس الأخضر" },
        { name: "كورونا جمهورية التشيك" },
        { name: "فرنك جيبوتي" },
        { name: "كرونة دنماركية" },
        { name: "بيزو دومينيكاني" },
        { name: "دينار جزائري" },
        { name: "جنيه مصري" },
        { name: "ناكفا إريترية" },
        { name: "بر إثيوبي" },
        { name: "يورو" },
        // { name: "دولار فيجي" },
        // { name: "جنيه جزر فوكلاند" },
        { name: "جنيه إسترليني" },
        { name: "لاري جورجي" },
        // { name: "جنيه جيرنسي" },
        { name: "سيدي غاني" },
        { name: "جنيه جبل طارق" },
        { name: "دالاسي غامبيا" },
        { name: "فرنك غيني" },
        // { name: "كوازال غواتيمالي" },
        // { name: "دولار جوياني" },
        { name: "دولار هونج كونج" },
        // { name: "ليمبيرا هندوراس" },
        { name: "كونا كرواتية" },
        // { name: "جورد هايتي" },
        { name: "فورنت مجري" },
        { name: "روبية إندونيسية" },
        // { name: "جنيه مانكس" },
        { name: "روبية هندية" },
        { name: "دينار عراقي" },
        { name: "ريال إيراني" },
        { name: "كرونا أيسلندية" },
        // { name: "جنيه جيرسي" },
        // { name: "دولار جامايكي" },
        { name: "دينار أردني" },
        { name: "ين ياباني" },
        { name: "شلن كيني" },
        // { name: "سوم قيرغيزستاني" },
        { name: "ريال كمبودي" },
        { name: "فرنك جزر القمر" },
        { name: "وون كوريا الشمالية" },
        { name: "وون كوريا الجنوبية" },
        { name: "دينار كويتي" },
        // { name: "دولار جزر كايمان" },
        { name: "تنغ كازاخستاني" },
        // { name: "كيب لاوسي" },
        { name: "ليرة لبنانية" },
        { name: "روبية سريلانكية" },
        // { name: "دولار ليبيري" },
        // { name: "لوتي ليسوتو" },
        { name: "دينار ليبي" },
        { name: "درهم مغربي" },
        { name: "ليو مولدوفا" },
        // { name: "أرياري مدغشقر" },
        { name: "دينار مقدوني" },
        { name: "ميانما كيات" },
        { name: "توغريك منغولي" },
        // { name: "باتاكا ماكاوية" },
        { name: "أوقية موريتانية" },
        { name: "روبية موريشيوسية" },
        { name: "روفية جزر مالديف" },
        // { name: "كواشا مالاوي" },
        { name: "بيزو مكسيكي" },
        { name: "رينغيت ماليزيا" },
        { name: "ميتيكال موزمبيق" },
        { name: "دولار ناميبي" },
        { name: "نايرا نيجيرية" },
        // { name: "قرطبة نيكاراغوا" },
        { name: "كرونة نرويجية" },
        { name: "روبية نيبالية" },
        { name: "دولار نيوزيلندي" },
        { name: "ريال عماني" },
        { name: "بالبوا بنمي" },
        { name: "نويفو سول بيرو" },
        { name: "كينا بابوا غينيا جديدة" },
        { name: "بيزو فلبيني" },
        { name: "روبية باكستانية" },
        { name: "زلوتي بولندي" },
        { name: "غواراني باراغواي" },
        { name: "ريال قطري" },
        { name: "ليو روماني" },
        { name: "دينار صربي" },
        { name: "روبل روسي" },
        { name: "فرنك رواندي" },
        { name: "ريال سعودي" },
        { name: "دولار جزر سليمان" },
        // { name: "روبية سيشيلية" },
        { name: "جنيه سوداني" },
        { name: "كرونا سويدية" },
        { name: "دولار سنغافوري" },
        // { name: "جنيه سانت هيلينا" },
        { name: "ليون سيراليوني" },
        { name: "شلن صومالي" },
        // { name: "دولار سورينامي" },
        { name: "جنيه جنوب سودان" },
        // { name: "ساو تومي وبرينسيبي دوبرا (ما قبل 2018)" },
        // { name: "ساو تومي وبرينسيبي دوبرا" },
        // { name: "كولون سلفادوري" },
        { name: "ليرة سورية" },
        // { name: "ليلانجيني سوازي" },
        { name: "بات تايلندي" },
        { name: "سوموني طاجيكي" },
        { name: "مانات تركمانستان" },
        { name: "دينار تونسي" },
        // { name: "تونغا بانجا" },
        { name: "ليرة تركية" },
        // { name: "دولار ترينيداد وتوباغو" },
        // { name: "دولار تايوان الجديد" },
        // { name: "شلن تنزاني" },
        { name: "هريفنيا أوكراني" },
        { name: "شلن أوغندي" },
        { name: "دولار أمريكي" },
        { name: "بيزو أوروغواي" },
        { name: "سوم أوزبكستان" },
        // { name: "بوليفار فويرتي الفنزويلي (قديم)" },
        { name: "بوليفار سوبيرانو الفنزويلي" },
        { name: "دونغ فيتنامي" },
        // { name: "فاتو فانواتو" },
        // { name: "ساموا تالا" },
        // { name: "فرنك CFA" },
        // { name: "أونصة فضة" },
        // { name: "أونصة الذهب" },
        // { name: "دولار شرق الكاريبي" },
        // { name: "حقوق السحب الخاصة" },
        // { name: "فرنك CFA BCEAO" },
        // { name: "أونصة البلاديوم" },
        // { name: "فرنك سي إف بي" },
        // { name: "أونصة البلاتين" },
        { name: "ريال يمني" },
        { name: "راند جنوب أفريقيا" },
        // { name: "زامبيان كواشا" },
        { name: "دولار زيمبابوي" }
    ];

    getAll(): CurrencyName[] {
        this.currencies.sort((a, b) => a.name.localeCompare(b.name)); 
        return this.currencies;
    }
}
